import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { can } from '../authz/access.js';
import { getSubject } from '../authz/subject.js';
import { ClassRoom } from '../classroom.js';

export const getClassRoomsByIdsQuery = registerQuery({
  operationName: 'getClassRoomsByIdsQuery',
  type: () => [ClassRoom],
  params: [{ name: 'ids', type: () => [String] }],

  resolve: (ids: string[]) => async (_gqlFields: BaseQLSelectionSet<ClassRoom>): Promise<ClassRoom[]> => {
    const normalizedIds = Array.isArray(ids) ? ids.filter(id => typeof id === 'string' && id.length > 0) : [];
    if (normalizedIds.length === 0) return [];

    const classroomCollection = await getCollection(ClassRoom);
    const classrooms = await classroomCollection.find({ _id: { $in: normalizedIds } }).toArray();

    // The owner sees everything; a (pending/approved) member sees the class without its join `code`, which
    // would let them hand out access; anyone else gets nothing.
    const { teacherId } = await getSubject();
    const readable = await Promise.all(classrooms.map(classroom => can(ClassRoom, 'read', classroom)));
    const visible = (classrooms as any[])
      .filter((_classroom, index) => readable[index])
      .map(classroom => {
        if (teacherId && classroom.teacherID === teacherId) return classroom;
        const { code: _code, ...withoutCode } = classroom;
        return withoutCode;
      });

    return visible as ClassRoom[];
  },
});
